import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig.js';

const environment = import.meta.env.MODE;

const originalImageKey = 'ai/input/video/';
export default {
    libPath: environment === LOCAL ? `/public/lib/` : `/app/ai-tools/lib/`,
    originalImageKey: originalImageKey,
    resultVideoKey: 'ai/export/video/',
    resultCoverKey: 'ai/export/video/cover/',
    historyListType: 14,
    freeLimitType: 'video-generator',
    currentMenuName: 'ai-video-generator',

    presetPreviewPath:
        environment === LOCAL ? `/public/resource/AIVideoGenerator/` : `/app/ai-tools/resource/AIVideoGenerator/`,
    presetListJsonPath:
        environment === LOCAL
            ? `/public/preloadData/AIVideoGenerator/AIVideoGeneratorPresetList.json?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/preloadData/AIVideoGenerator/AIVideoGeneratorPresetList.json?v=${FJVersionConfig.staticPathVersion}`,

    originImagePath: [
        originalImageKey,
        'ai/export/text2img/',
        'ai/export/img2img/',
        '/app/ai-tools/resource/AIVideoGenerator/',
    ],

    inspireListJsonPath:
        environment === LOCAL
            ? `/public/preloadData/AIVideoGenerator/AIVideoGeneratorInspireList.json?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/preloadData/AIVideoGenerator/AIVideoGeneratorInspireList.json?v=${FJVersionConfig.staticPathVersion}`,
};
